import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "../__root";

export const userPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/user/password",
  component: lazyRouteComponent(
    () =>
      import(
        /* webpackChunkName: "DiscoverForgotPasswordPage" */ "@circle-react/components/Discover/ForgotPasswordPage"
      ),
    "ForgotPasswordPage",
  ),
});
